// function isInViewport(el) {
//     const rect = el?.getBoundingClientRect();
//     return (
//         rect.top >= 0 &&
//         rect.left >= 0 &&
//         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
//         rect.right <= (window.innerWidth || document.documentElement.clientWidth)

//     );
// }
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.addToCartBtn = this.querySelector('.product-form__submit');

      // document.addEventListener('scroll', this.handleCTAbutton.bind(this), { passive: true });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {console.log(response);
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          const shopTheLookModal = this.closest('modal-dialog');
          if (quickAddModal || shopTheLookModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            if (quickAddModal) {
              quickAddModal.hide(true);
            } else {
              shopTheLookModal.hide(true);
            }
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          $.ajax({
            type: "GET",
            url: '/cart.js',
              dataType: 'json', 
            success: function(data) {
              if(data) {
                console.log(data);
                var obj = data.items;
                var gtot = 0;
                $.each(obj, function(key,value) {
                  gtot = (value.grams*value.quantity)+gtot;
                });
                var weight = Math.round(gtot/453.6),
                percentage = Math.round(((Math.round(gtot/453.6))/1200)*100),
                  modulo = ((weight % 250)-250)*-1,
                  pt = percentage + "%";
                console.log(pt);
                $('.progress-value').each(function(){
                  $(this).removeClass('animated').css('width',pt);
                });
                $('.addmore .weight').each(function(){
                  $(this).text(modulo);
                });
              }
              /// estimator
              if($('#shipping-estimates .totals-est').length > 0){
                $.ajax({
                  type: "POST",
                  url: '//hook.us1.make.celonis.com/b10fd8ltisl5fzxo7728u6tst301how6',
                  data:data,
                  dataType: 'json', 
                  success: function(data) {
                  console.log('shipping estimate',data);
                      const { service_name, max_delivery_date, min_delivery_date, total_price } = data.rates[0];                         
                      console.log(data.rates[0].total_price);
                var mny = data.rates[0].total_price,
                  mnytot = data.rates[0].original_price;
                $('#shipping-estimates .totals-est').text("$"+parseInt(mny)/100);
                $('#shipping-estimates2 .totals-est').text("$"+parseInt(mny)/100);
                $('#shipping-estimates .totals-esttot').text(mnytot);
                $('#shipping-estimates2 .totals-esttot').text(mnytot);
                }
              });
              }
            }
          });
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
         if(errorMessage.email){
        this.errorMessage.textContent = "Email" + ' ' + errorMessage.email;
         }
        else{
          this.errorMessage.textContent = errorMessage;
        }
      }
    }

    // handleCTAbutton() {
    //   const cartAvailable = isInViewport(this.addToCartBtn);
    //   const floatingCTA = document.querySelector('.js-pdp-floating-cta');
    //   const addToCart = this.querySelector('.product-form__submit');
    //   const floatingCTAHTML = `<div class="product-form-floating-cta js-pdp-floating-cta"><button aria-label="Add to Bag" class="floating-add-to-cart-btn button button--full-width button--primary"><span>Add to cart</span></button></div>`;

    //   if(window.innerWidth < 768){
    //     if(cartAvailable){
    //       if(floatingCTA){
    //         floatingCTA.remove();

    //       }
    //     }else{
    //       if(floatingCTA){
    //         floatingCTA.addEventListener('click', function(){
    //           addToCart.click();
    //         })
    //       } else {
    //         this.insertAdjacentHTML('beforeend', floatingCTAHTML);
    //       }        
    //     }
    //   }
    // }
  });
}
